export default {
  methods: {
    format_question_type(type) {
      if (!type || typeof type !== 'string') {
        return "Unknown Type";
      }

      if (type === "Vetted") {
        return "Approved";
      }

      return type.charAt(0).toUpperCase() + type.slice(1).replace(/_/g, ' ');
    },

    format_date(dateString, fall_back_message = "-") {
      const date = new Date(dateString);

      if (dateString === null || isNaN(date.getTime())) return fall_back_message;//fallback for invalid dates


      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      const ampm = hours >= 12 ? 'pm' : 'am';
      hours = String(hours % 12 || 12).padStart(2, '0');

      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}${ampm}`;
    },

    format_display_date(date_str) {
      if (!date_str) return '';
      const date = new Date(date_str);
      if (isNaN(date.getTime())) return date_str;
      return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    },

    format_display_datetime(date_str) {
      if (!date_str) return '';
      const date = new Date(date_str);
      if (isNaN(date.getTime())) return date_str;

      const has_time =
        typeof date_str === 'string'
        && (/[T\s]\d{2}:\d{2}/.test(date_str) || /\d{2}:\d{2}/.test(date_str));

      const formatted_date = date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });

      if (!has_time) {
        return formatted_date;
      }

      const formatted_time = date.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });

      const period = date.getHours() < 12 ? 'AM' : 'PM';

      return `${formatted_date} - ${formatted_time} ${period}`;
    }
  }
};
